export const FETCH_RISKFACTOR_DETAILS = 'src/component/RiskFactor/View/Fetch_Riskfactor_Details';
export const FETCH_RISKFACTOR_DETAILS_SUCCESS = 'src/component/RiskFactor/View/Fetch_Riskfactor_Details_Success';
export const FETCH_RISKFACTOR_DETAILS_FAILURE = 'src/component/RiskFactor/View/Fetch_Riskfactor_Details_Failure';

export const fetchRiskFactorDetails = (data) => {
    return {
        type: FETCH_RISKFACTOR_DETAILS,
        data
    }
}
export const fetchRiskFactorDetailsSuccess = (data) => {
    return {
        type: FETCH_RISKFACTOR_DETAILS_SUCCESS,
        data
    }
}
export const fetchRiskFactorDetailsFailure = (data) => {
    return {
        type: FETCH_RISKFACTOR_DETAILS_FAILURE,
        data
    }
}

export const DOWNLOAD_RISKFACTOR_DETAILS = 'src/component/RiskFactor/View/Download_Riskfactor_Details';
export const downloadRiskfactorDetails = (data) => {
    return {
        type: DOWNLOAD_RISKFACTOR_DETAILS,
        data
    }
}

export const UPLOAD_RISKFACTOR_DETAILS = 'src/component/RiskFactor/View/Upload_Riskfactor_Details';

export const uploadRiskfactorDetails = (data) => {
    return {
        type: UPLOAD_RISKFACTOR_DETAILS,
        data
    }
}

